import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  REACT_APP_PRIVACY_POLICY_URL,
  YACHTWORLD_LOGO,
  TRIDENT_LOGO,
  BOAT_PICTURE,
  CLOSE_ICON,
  CHECK_CIRCLE
} from '../../constants/BoatLoans';
import { listingPropTypes } from '../../utils/commonPropTypes';
import { formatMessage } from '../../utils/language';
import GetPreQualifiedForm from '../GetPreQualifiedForm';
import messages from '../../utils/translationMessages';

import Modal from '../Modal';

import './styles.css';

export const GET_PREQUALIFIED_SUCCESS_CLOSE_TIMEOUT = 9000;

const customStyles = {
  content: {
    overflow: 'visible',
    padding: '0',
    borderRadius: '1rem',
    border: 'unset'
  },
  overlay: {
    backgroundColor: 'rgb(34 27 34 / 50%)'
  }
};

const { modal } = messages.boatLoansLeads.getPreQualified;

export const GetPreQualifiedHeader = () => {
  return (
    <div className="prequalified-title">
      <img
        className="prequalified-icon-boat"
        src={BOAT_PICTURE}
        alt="Boat Icon"
      />
      <div className="prequalified-logo-financing">
        <img
          alt="YachtWorldLogo"
          className="prequalified-img-logo"
          src={YACHTWORLD_LOGO}
        />
        <div className="prequalified-financing">
          {formatMessage(modal.financing)}
        </div>
      </div>
    </div>
  );
};

export const GetPreQualifiedFooter = () => {
  /* eslint-disable react/jsx-no-target-blank */

  return (
    <>
      <div className="prequalified-powered-by">
        <div className="powered-by-title">{formatMessage(modal.poweredBy)}</div>
        <img
          className="trident-logo"
          src={TRIDENT_LOGO}
          alt="Trident Funding Logo"
        />
      </div>
      <div className="prequalified-privacy-policy">
        <a
          href={REACT_APP_PRIVACY_POLICY_URL}
          target="_blank"
          rel="noopener nofollow"
          data-wpel-link="external"
        >
          {formatMessage(modal.privacy)}
        </a>
      </div>
    </>
  );
};

export const GetPreQualifiedSuccess = ({ onClose }) => {
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      onClose();
    }, GET_PREQUALIFIED_SUCCESS_CLOSE_TIMEOUT);
  });

  const onCloseHandler = () => {
    setIsOpen(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      portalClassName="prequalified-modal-container"
      contentLabel="Prequalified success"
      injectedStyles={customStyles}
    >
      <div
        className="prequalified-success"
        data-testid="prequalified-success-toast"
        id="prequalified-success-toast"
      >
        <div
          style={{
            background: `url('${CHECK_CIRCLE}') no-repeat center center transparent`
          }}
          className="prequalified-success-logo"
        ></div>
        <div className="prequalified-success-info">
          {formatMessage(modal.success)}
        </div>
        <button
          style={{
            background: `url('${CLOSE_ICON}') no-repeat center center transparent`
          }}
          className="modal-close"
          data-testid="close-prequalified-success"
          id="close-prequalified-success"
          onClick={onCloseHandler}
        >
          <span className="visuallyhidden">{formatMessage(modal.close)}</span>
        </button>
      </div>
    </Modal>
  );
};

GetPreQualifiedSuccess.propTypes = {
  onClose: PropTypes.func.isRequired
};

export const GetPreQualifiedModal = ({
  listing,
  interestRate,
  monthlyPrice,
  onClose,
  leadPage,
  ficoScores
}) => {
  const [isOpen, setIsOpen] = useState(true);
  const [isSuccess, setIsSuccess] = useState(false);

  const onCloseHandler = () => {
    setIsOpen(false);
    onClose();
  };

  const onSuccess = () => {
    setIsSuccess(true);
  };

  return (
    <>
      {!isSuccess && (
        <Modal
          isOpen={isOpen}
          portalClassName="prequalified-modal-container"
          contentLabel="Prequalified modal"
          injectedStyles={customStyles}
        >
          <div className="prequalified-container">
            <div className="prequalified-bar">
              <GetPreQualifiedHeader />
              <button
                id="modal-close"
                style={{
                  background: `url('${CLOSE_ICON}') no-repeat center center transparent`
                }}
                className="modal-close"
                onClick={onCloseHandler}
              >
                <span className="visuallyhidden">
                  {formatMessage(modal.close)}
                </span>
              </button>
            </div>
            <GetPreQualifiedForm
              listing={listing}
              interestRate={interestRate}
              monthlyPrice={monthlyPrice}
              onSuccess={onSuccess}
              leadPage={leadPage}
              ficoScores={ficoScores}
            />
            <GetPreQualifiedFooter />
          </div>
        </Modal>
      )}

      {isSuccess && <GetPreQualifiedSuccess onClose={onClose} />}
    </>
  );
};

GetPreQualifiedModal.propTypes = {
  listing: listingPropTypes,
  monthlyPrice: PropTypes.string,
  interestRate: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  leadPage: PropTypes.string,
  ficoScores: PropTypes.array
};
